import {configureStore} from '@reduxjs/toolkit';
import storage from "redux-persist/lib/storage"; // Use localStorage as default storage
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import appReducer from './slices/app';
import authReducer from "./slices/authSlice.js";
import currencyReducer from "../src/features/currency/currencySlice.js";
import expenseReducer from "../src/features/expenses/expenseSlice.js"
const persistConfig = {
  key: "root", // Key for storing state
  storage, // Storage engine (localStorage)
};

const rootReducer = combineReducers({
  app: persistReducer(persistConfig, appReducer),
  auth: authReducer,
  currency:currencyReducer,
  expense:expenseReducer
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Prevents Redux Persist serialization warning
    }),
});

export const persistor = persistStore(store);